import { Attr, BelongsTo, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type Outlet from "./Outlet";

@Model()
class OutletType extends ApplicationRecord {
  static jsonapiType = "outlet_types";

  @Attr() name: string;

  @BelongsTo() outlet: Outlet;
}

export default OutletType;
